import { rankEntries } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

const toneStyles: Record<
  string,
  { ring: string; icon: string; chip: string; bar: string }
> = {
  primary: {
    ring: "hover:border-primary-300",
    icon: "bg-primary-500 text-background-50",
    chip: "bg-primary-100 text-primary-700",
    bar: "bg-primary-500",
  },
  accent: {
    ring: "hover:border-accent-300",
    icon: "bg-accent-500 text-foreground-950",
    chip: "bg-accent-100 text-accent-800",
    bar: "bg-accent-500",
  },
  secondary: {
    ring: "hover:border-secondary-300",
    icon: "bg-secondary-500 text-background-50",
    chip: "bg-secondary-100 text-secondary-800",
    bar: "bg-secondary-500",
  },
  foreground: {
    ring: "hover:border-foreground-300",
    icon: "bg-foreground-900 text-background-50",
    chip: "bg-background-200 text-foreground-800",
    bar: "bg-foreground-800",
  },
};

export default function RankEntry() {
  return (
    <section id="rank-entry" className="w-full bg-background-50 px-4 py-10 md:px-6 md:py-14">
      <div className="mx-auto max-w-[1280px]">
        <SectionHeading
          eyebrow="Ranking Index"
          title="四大榜单入口，按需求直接进"
          desc="不知道怎么挑？先按你的浏览意图选一个入口：想看口碑冲高分榜，想追热度看人气榜，想省时间直接进合辑。"
          actionText="查看全部榜单"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {rankEntries.map((entry) => {
            const tone = toneStyles[entry.tone] ?? toneStyles.primary;
            return (
              <a
                key={entry.id}
                href={entry.id === "r4" ? "#collections" : "#popular"}
                className={`group flex flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-all hover:-translate-y-0.5 ${tone.ring}`}
              >
                <div className="flex items-start justify-between">
                  <span className={`flex h-12 w-12 items-center justify-center rounded-lg ${tone.icon}`}>
                    <i className={`${entry.icon} text-2xl`} />
                  </span>
                  <span className={`rounded-full px-2.5 py-1 text-[11px] font-semibold ${tone.chip}`}>
                    {entry.count}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{entry.title}</h3>
                <p className="mt-1 text-xs text-foreground-500">{entry.subtitle}</p>

                <div className="mt-4 flex flex-col gap-1.5 border-t border-background-200 pt-4">
                  {entry.samples.map((sample) => (
                    <span key={sample} className="flex items-center gap-1.5 text-xs text-foreground-600">
                      <span className={`h-1 w-1 rounded-full ${tone.bar}`} />
                      {sample}
                    </span>
                  ))}
                </div>

                <span className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-primary-600 transition-transform group-hover:translate-x-0.5">
                  进入榜单
                  <i className="ri-arrow-right-line text-sm" />
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}